'use strict';

var _createClass = function() {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

function _classCallCheck(instance, Constructor) {
    if (!(
        instance instanceof Constructor
    )) {
        throw new TypeError('Cannot call a class as a function');
    }
}

/* SideNav */
(
    function($) {

        var SideNav = function() {
            function SideNav(element, options) {
                var _this = this,
                    elementId = element.id;

                console.log('SideNav', 'this', this, element);
                return this;

            }

            _createClass(SideNav, [
                {
                    key: 'removeMenu',
                    value: function removeMenu(restoreMenu) {
                        var _this2 = this;

                        $('body').css({
                            overflow: '',
                            width: ''
                        });

                        if (this.options.edge === 'left') {
                            this.menu_id.velocity({
                                translateX: '-100%'
                            }, {
                                duration: 200,
                                queue: false,
                                easing: 'easeOutCubic',
                                complete: function complete() {
                                    if (restoreMenu === true) {
                                        _this2.menu_id.removeAttr('style');
                                        _this2.menu_id.css('width', _this2.options.MENU_WIDTH);
                                    }
                                }
                            });
                        } else {
                            this.menu_id.velocity({
                                translateX: '100%'
                            }, {
                                duration: 200,
                                queue: false,
                                easing: 'easeOutCubic',
                                complete: function complete() {
                                    if (restoreMenu === true) {
                                        _this2.menu_id.removeAttr('style');
                                        _this2.menu_id.css('width', _this2.options.MENU_WIDTH);
                                    }
                                }
                            });
                        }

                        $('#sidenav-overlay').velocity({
                            opacity: 0
                        }, {
                            duration: 200,
                            queue: false,
                            easing: 'easeOutQuad',
                            complete: function complete() {
                                $('#sidenav-overlay').remove();
                            }
                        });
                    }
                }, {
                    key: 'show',
                    value: function show() {
                        this.trigger('click');
                    }
                }, {
                    key: 'hide',
                    value: function hide() {
                        $('#sidenav-overlay').trigger('click');
                    }
                }
            ]);

            return SideNav;
        }();
        //        console.log('SideNav', 'SideNav',SideNav);

        $.fn.sideNav = function(options) {
            return this.each(function() {
                new SideNav($(this), options);
            });
        };
    }
)(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/components/navigation/_sidenav.js